import Page from './Page';
import Component from 'vue-class-component';

import template from './MerchandiseList.vue.html';
import MerchandiseCarousel from '../common/merchandise/MerchandiseCarousel.vue';
import MerchandiseItemCard from '../common/merchandise/MerchandiseItemCard.vue';
import HeaderComponent from './Header.vue';
import TabBar from './TabBar.vue';
import { MerchandiseItem } from './app';
import { Image } from './MerchandiseCategories.vue';

@Component({
    template,
    components: {
        MerchandiseCarousel,
        MerchandiseItemCard,
        HeaderComponent,
        TabBar,
    },
})
export default class MerchandiseList extends Page {
    merchandise_items: MerchandiseItem[] = [];

    pickedUpImages: Image[] = [];

    created() {
        for (const merchandise of this.app.mobile_order_merchandises) {
            if (merchandise.category === this.app.query.category) {
                this.merchandise_items.push(merchandise);

                const recommendation = merchandise.merchandise_recommendation;
                if (!recommendation.is_general && recommendation.valid) {
                    this.pickedUpImages.push({
                        merchandise_item_id: merchandise.id,
                        filepath: merchandise.image_urls[0],
                    });
                }
            }
        }
    }

    setMerchandiseItem(merchandiseItemId: number) {
        this.app.updateQuery({
            merchandiseItemId,
            page: 'MerchandiseDetail',
            category: this.app.query.category,
        });
    }
}
